import React from 'react';
import CompanyStartScreen from './screens/CompanyStartScreen/CompanyStartScreen';

function CompanyStart() {
  return (
    <>
      <CompanyStartScreen />
    </>
  );
}

export default CompanyStart;
